export enum BusinessType {
    Corporate = 'Corporate',
    Partnership = 'Partnership',
    Proprietorship = 'Proprietorship'
}